module.exports = window["wp"]["editSite"];